import * as React from "react";
import { Show, SimpleShowLayout,useRecordContext,Button, TextField,FunctionField } from 'react-admin';
const PageTitle = () => {
    const record = useRecordContext();
    return <span>User {record ? `${record.name}` : ''}</span>;
  };
const ProductIntentTesterTaskDetail = ({...props }) => (

    <Show title={<PageTitle />} {...props}>
        <SimpleShowLayout>
        <TextField source="id" />
        <TextField source="profile_id"  label="Profile ID"/>  
        <TextField source="name"  label="Name"/>       
        <TextField source="radio_label1" label="Question 1" />
        <TextField source="radio_label1" label="Question 2" />  
        <TextField source="text_field_value" label="Current Price of Product/Service" />           
        <TextField source="task_amount" label="Amount" />  
        <TextField source="status" label="Status" />
        <TextField source="declineby.name" label="Rejected by" />
        <TextField source="approvedby.name" label="Approved by" />
        <TextField source="decline_reason" label="Decline reason" />
        <TextField source="approved_at" label="Approved Date" />
        <TextField source="rejected_at" label="Rejected Date" />
        <TextField source="created_at" label="Created At" />
        <TextField source="updated_at" label="Updated At" />
        </SimpleShowLayout>
    </Show>
     );
export default ProductIntentTesterTaskDetail